var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrowBox"},[_c('div',{ref:"arrow"},[_c('v-icon',{attrs:{"color":_vm.color,"size":"30"}},[_vm._v("mdi-navigation")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }